import { PlusCircleOutlined } from "@ant-design/icons";
import { Trash2 } from "lucide-react";
import React, { useState } from "react";
import Modal from "../../../components/Model/Modal";
import Button from "../../../components/core/Element/Button/Button";

const Banners = ({ banners = [], uploadBanner, deleteBanner }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(false);
  const bannerSlots = Array.from(
    { length: 6 },
    (_, index) => banners[index] || null
  );

  return (
    <div className="d-flex flex-column gap-3 bg-light mt-3">
      <h3>Promotional Banners</h3>
      <h4 className="description">
        Attract more attention from your customers with promotional banners
        displayed on the top of your homepage.
      </h4>

      <div className="banners-grid">
        {bannerSlots.map((banner, index) => (
          <div
            key={index}
            className="banner-card"
            onClick={() =>
              !banner &&
              document.getElementById(`banner-upload-${index}`).click()
            }
          >
            {banner ? (
              <>
                <img
                  src={banner.imageUrl}
                  alt={`Banner ${index + 1}`}
                  className="banner-image"
                />
                <div
                  className="delete-banner"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedBanner(banner._id);
                  }}
                >
                  <Trash2 className="icon" />
                </div>
              </>
            ) : (
              <div className="add-banner-content">
                <PlusCircleOutlined />
                <p>Add Banner</p>
              </div>
            )}
            <input
              type="file"
              id={`banner-upload-${index}`}
              accept="image/*"
              style={{ display: "none" }}
              onChange={(event) => uploadBanner(event, index)}
            />
          </div>
        ))}
      </div>
      <Modal
        show={showModal}
        title={"Delete Banner"}
        onClose={() => setShowModal(false)}
        footer={
          <Button
            label="Delete"
            onClick={() => deleteBanner(selectedBanner, setShowModal)}
            iconAlignLeft
          />
        }
      >
        <span>Are you sure want to delete this banner?</span>
      </Modal>
    </div>
  );
};

export default Banners;
